class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onWidePanelResize = this.positionWidePanel.bind(this);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.positionWidePanel();
      window.addEventListener('resize', this.onWidePanelResize);
    } else {
      this.resetWidePanel();
      window.removeEventListener('resize', this.onWidePanelResize);
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  get widePanel() {
    return this.content?.classList.contains('header__submenu--product-solutions') ? this.content : null;
  }

  resetWidePanel() {
    const panel = this.widePanel;
    if (!panel) return;
    panel.style.left = '';
  }

  positionWidePanel() {
    const panel = this.widePanel;
    if (!panel || !this.mainDetailsToggle.open) return;

    panel.style.left = '0px';

    requestAnimationFrame(() => {
      const padding = 16;
      const rect = panel.getBoundingClientRect();
      let shift = 0;

      if (rect.right > window.innerWidth - padding) {
        shift = window.innerWidth - padding - rect.right;
      }

      if (rect.left + shift < padding) {
        shift = padding - rect.left;
      }

      panel.style.left = `${shift}px`;
    });
  }
}

customElements.define('header-menu', HeaderMenu);
